import { render, staticRenderFns } from "./ChallengesTransactions.vue?vue&type=template&id=dc58e27c&scoped=true&"
import script from "./ChallengesTransactions.vue?vue&type=script&lang=js&"
export * from "./ChallengesTransactions.vue?vue&type=script&lang=js&"
import style0 from "./ChallengesTransactions.vue?vue&type=style&index=0&id=dc58e27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc58e27c",
  null
  
)

export default component.exports